import {
    AfterViewInit,
    Component,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import { VideoGalleryService } from '../../../core/services/video-gallery.service';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { environment } from 'src/environments/environment';
import * as gtag from 'src/app/core/utils/gtag';

declare var $: any;
declare let fbq: Function;

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent implements OnInit, AfterViewInit {
    public isHomePage: boolean;
    public isMarketing: boolean;
    public videoUrl: string;
    isMobile = false;

    constructor(
        private router: Router,
        private videoGalleryService: VideoGalleryService,
        private fireStorage: AngularFireStorage
    ) {}

    ngOnInit() {
        this.isHomePage = [
            '/',
            '/benefits',
            '/about-us',
            '/imprint',
            '/privacy',
            '/faqbereichag',
            '/steuerfinanziert-mehr-netto',
        ].some(path => this.router.url.includes(path));

        this.isMarketing = [
            '/systemeinblickkompakt',
            '/teaserundsystemeinblick',
        ].some(path => this.router.url.includes(path));

        if (this.isHomePage) {
            this.fetchVideo();
        }

        this.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

        $('.intro-video-modal').on('shown.bs.modal', () => {
            $('.intro-video')[0].play();
            if (environment.production) {
                gtag.event({
                    action: 'video-how-it-works-played',
                    category: 'main_functions',
                    label: 'The Video "How it works" was played',
                    value: 1,
                });
                fbq('track', 'Video (How it works) played');
            }
        });

        $('.intro-video-modal').on('hidden.bs.modal', () => {
            $('.intro-video')[0].pause();
        });
    }

    ngAfterViewInit() {
        $('.contact a').click((event) => {
            event.preventDefault();
            const target = 'contact-form';
            const targetSelector = '#' + target;
            const targetHeight = $(targetSelector).height();
            const targetOffset = $(targetSelector).offset();
            const targetPercentage = (targetHeight * 90) / 100;
            const targetTop = targetOffset.top;
            $('html, body').animate(
                { scrollTop: targetTop - (targetHeight - targetPercentage) },
                500
            );
        });
    }

    closeIntroVideoModal() {
        $('.intro-video-modal').modal('hide');
        const element = $('.calculator-full');
        $('html, body').animate(
            {
                scrollTop: element.offset().top - element[0].offsetHeight,
            },
            1000
        );
    }

    private fetchVideo() {
        this.fireStorage.storage
            .ref("website-videos/public/teaser-video-ag.mp4")
            .getDownloadURL()
            .then((url) => {
                this.videoUrl = url;
            });
    }

    disableHeader() {
        return ['/privacy', '/imprint'].includes(this.router.url.split('?')[0]);
    }

    get activeRoute(): string {
        return this.router.url.split('?')[0];
    }
}
